import React from 'react';

export interface BasicType {
  children?: React.ReactNode;
  location?: any;
  routeList?: any[];
  isOpen?: boolean;
}

export enum HeaderStatus {
  RESET_PASSWORD = 'resetPassword',
  LOGIN_OUT = 'loginOut',
}
